module.exports = __webpack_public_path__ + "img/kappverde_1.00d74fca.jpg";